import React, { useContext, useState, useEffect } from "react"
import { Main, Wrapper, RightSideBar } from "./style"
import GridIcon from "./GridIcon"
import FlexIcon from "./FlexIcon"
import { ViewContext } from "../../../contexts/ViewContext"
import { FlatsContext } from "../../../contexts/FlatsContext"
import { useStaticQuery, graphql } from "gatsby"
import { useIntl } from "gatsby-plugin-react-intl"
import { SearchOptionsContext } from "../../../contexts/SearchOptionsContext"
import SelectSearch from "react-select-search"
import "../../SearchComponent/select-style.css"

const SortBar = () => {
  const [displayType, setDisplayType] = useContext(ViewContext)
  const [flats, loading, filteredFlats, setFilteredFlats] =
    useContext(FlatsContext)
  const [searchData, setSearchData, sortingType, setSortingType] =
    useContext(SearchOptionsContext)
  const changeView = type => {
    setDisplayType(type)
  }
  const isBrowser = typeof window !== "undefined"
  const intl = useIntl()
  const [queryData, setQueryData] = useState({})
  const [selectedSort, setSelectedSort] = useState("")

  const query = useStaticQuery(graphql`
    query SortBarQuery {
      polish: contentfulSearch(node_locale: { eq: "pl-PL" }) {
        realStatesCount
        flat
        house
        land
        local
        sortDefault
        sortPrice1
        sortPrice2
        sortDate1
        sortDate2
      }
      english: contentfulSearch(node_locale: { eq: "en-US" }) {
        realStatesCount
        flat
        house
        land
        local
        sortDefault
        sortPrice1
        sortPrice2
        sortDate1
        sortDate2
      }
    }
  `)

  const realStatesSwitch = propertyType => {
    switch (propertyType) {
      case "flat":
        return queryData.flat

      case "land":
        return queryData.land
      case "house":
        return queryData.house
      case "usable_locale":
        return queryData.local
      default:
        return queryData.realStatesCount
    }
  }

  useEffect(() => {
    if (isBrowser) {
      if (intl.locale === "en") {
        setQueryData(query.english)
      }
      if (intl.locale === "pl") {
        setQueryData(query.polish)
      }
    }
  }, [intl])

  const updateSorting = value => {
    const data = value.split("-")

    setSelectedSort(value)
    setSortingType({
      column: data[0],
      direction: data[1],
    })
  }

  return (
    <Main>
      <Wrapper>
        <h2>
          {realStatesSwitch(searchData.propertyType)} ({filteredFlats.length}):
        </h2>
        <RightSideBar>
          <GridIcon changeView={changeView} displayType={displayType} />
          <FlexIcon changeView={changeView} displayType={displayType} />
          <SelectSearch
            onChange={updateSorting}
            value={selectedSort}
            options={[
              { name: queryData.sortDefault, value: "" },

              { name: queryData.sortPrice1, value: "PRICE-ASC" },

              { name: queryData.sortPrice2, value: "PRICE-DESC" },

              { name: queryData.sortDate1, value: "DATE-DESC" },

              { name: queryData.sortDate2, value: "DATE-ASC" },
            ]}
          />
        </RightSideBar>
      </Wrapper>
    </Main>
  )
}

export default SortBar
